<template>
  <b-row>
    <b-col cols="12">
      <b-card title="Product List">
        <product-table />
      </b-card>
    </b-col>

    <b-col cols="12">
      <b-card title="Parameter List">
        <parameter-table />
      </b-card>
    </b-col>

    <b-col cols="12">
      <b-card title="Group List">
        <category-table />
      </b-card>
    </b-col>
  </b-row>
</template>

<script>
import {
  BRow,
  BCol,
  BContainer,
  BFormGroup,
  BCard,
  BFormInput,
  BButton,
  BForm,
  BCardText,
} from 'bootstrap-vue'
import ProductTable from '@/views/admin/product/compare/ProductTable.vue'
import ParameterTable from '@/views/admin/product/compare/ParameterTable.vue'
import CategoryTable from '@/views/admin/product/compare/CategoryTable.vue'

export default {
  components: {
    BRow,
    BCol,
    BContainer,
    BFormGroup,
    BCard,
    BFormInput,
    BButton,
    BForm,
    BCardText,
    ProductTable,
    ParameterTable,
    CategoryTable,
  },

  data() {
    return {
      isLoading: false,
      maplink: '',
    }
  },

  mounted() {
    //
  },

  methods: {
    //
  },
}
</script>
